import { render, staticRenderFns } from "./DropdownOpenWithPlaceholder.vue?vue&type=template&id=03fed4a6"
import script from "./DropdownOpenWithPlaceholder.vue?vue&type=script&lang=js"
export * from "./DropdownOpenWithPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports